var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { "data-grm-comp": "TestbankTable" } },
    [
      _c("div", { staticClass: "h-full flex-col hidden lg:flex" }, [
        _c("table", { staticClass: "test-bank-table" }, [
          _vm._m(0),
          _c("thead", { staticClass: "h-8 bg-gray-200" }, [
            _c("tr", [
              _c("th", [_vm._v(_vm._s(_vm.$t("common.number")))]),
              _c("th", [_vm._v(_vm._s(_vm.$t("setting.name.title")))]),
              _c("th", [_vm._v(_vm._s(_vm.$t("testBank.number.paper")))]),
              _c("th", [_vm._v(_vm._s(_vm.$t("link.regDate")))]),
              _c("th"),
            ]),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "max-h-full overflow-y-auto scrollbar-hidden" },
          [
            _c("table", { staticClass: "test-bank-table" }, [
              _vm._m(1),
              _c(
                "tbody",
                [
                  [
                    _vm._l(_vm.testbankList.content, function (testbank, i) {
                      return _c(
                        "tr",
                        {
                          key: testbank.bankId,
                          staticClass:
                            "cursor-pointer transition hover:bg-gray-100",
                          on: {
                            click: function ($event) {
                              return _vm.onSelectTestbank(testbank)
                            },
                          },
                        },
                        [
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm.isEditTestbank(testbank)
                                  ? "-"
                                  : _vm.testbankNum(i)
                              )
                            ),
                          ]),
                          _c(
                            "td",
                            [
                              _vm.isEditTestbank(testbank)
                                ? [
                                    _c("GrmTextField", {
                                      ref: "testbankTitle",
                                      refInFor: true,
                                      attrs: {
                                        value: testbank.bankTitle,
                                        size: "xs",
                                        textalign: "center",
                                      },
                                      on: {
                                        keydown: [
                                          function ($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "esc",
                                                27,
                                                $event.key,
                                                ["Esc", "Escape"]
                                              )
                                            )
                                              return null
                                            return _vm.onCancelTestbank(
                                              $event,
                                              testbank
                                            )
                                          },
                                          function ($event) {
                                            if (
                                              !$event.type.indexOf("key") &&
                                              _vm._k(
                                                $event.keyCode,
                                                "enter",
                                                13,
                                                $event.key,
                                                "Enter"
                                              )
                                            )
                                              return null
                                            return _vm.onCreateTestbank(
                                              $event,
                                              testbank
                                            )
                                          },
                                        ],
                                        input: _vm.onChangeTestbankTitle,
                                      },
                                    }),
                                  ]
                                : [_vm._v(_vm._s(testbank.bankTitle))],
                            ],
                            2
                          ),
                          _c("td", [
                            _vm._v(_vm._s(testbank.bankExamSize ?? "-")),
                          ]),
                          _c("td", [_vm._v(_vm._s(testbank.regDate ?? "-"))]),
                          _c(
                            "td",
                            [
                              _vm.isEditTestbank(testbank)
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "w-full flex justify-center gap-x-1",
                                    },
                                    [
                                      _c(
                                        "GrmBtn",
                                        {
                                          attrs: { size: "xs" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onCreateTestbank(
                                                $event,
                                                testbank
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("common.register"))
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "GrmBtn",
                                        {
                                          attrs: { size: "xs", color: "red" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onCancelTestbank(
                                                $event,
                                                testbank
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$t("common.cancel"))
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _c(
                                    "GrmBtn",
                                    {
                                      attrs: { size: "xs", color: "red" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onDeleteTestbank(
                                            $event,
                                            testbank
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("common.delete")))]
                                  ),
                            ],
                            1
                          ),
                        ]
                      )
                    }),
                    !_vm.testbankList.content?.length
                      ? _c("tr", [
                          _c(
                            "td",
                            {
                              staticClass: "text-center",
                              attrs: { colspan: "5" },
                            },
                            [_vm._v(_vm._s(_vm.$t("testBank.notExist")))]
                          ),
                        ])
                      : _vm._e(),
                  ],
                ],
                2
              ),
            ]),
          ]
        ),
      ]),
      _c(
        "div",
        { staticClass: "flex flex-col gap-2 lg:hidden" },
        _vm._l(_vm.testbankList.content, function (testbank, i) {
          return _c(
            "div",
            { key: testbank.bankId, staticClass: "p-2 rounded bg-gray-100" },
            [
              _c("div", { staticClass: "flex" }, [
                _c("div", { staticClass: "w-28 py-2 px-3 text-sm" }, [
                  _vm._v(_vm._s(_vm.$t("common.number"))),
                ]),
                _c("div", { staticClass: "min-w-0 flex-1 py-2 px-3 text-sm" }, [
                  _vm._v(
                    _vm._s(
                      _vm.isEditTestbank(testbank) ? "-" : _vm.testbankNum(i)
                    )
                  ),
                ]),
              ]),
              _c("div", { staticClass: "flex" }, [
                _c("div", { staticClass: "w-28 py-2 px-3 text-sm" }, [
                  _vm._v(_vm._s(_vm.$t("setting.name.title"))),
                ]),
                _c(
                  "div",
                  { staticClass: "min-w-0 flex-1 py-1 px-3 text-sm lg:py-2" },
                  [
                    _vm.isEditTestbank(testbank)
                      ? [
                          _c("GrmTextField", {
                            ref: "testbankTitle",
                            refInFor: true,
                            attrs: { size: "xs" },
                            on: {
                              keydown: [
                                function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "esc",
                                      27,
                                      $event.key,
                                      ["Esc", "Escape"]
                                    )
                                  )
                                    return null
                                  return _vm.onCancelTestbank($event, testbank)
                                },
                                function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  )
                                    return null
                                  return _vm.onCreateTestbank($event, testbank)
                                },
                              ],
                            },
                            model: {
                              value: testbank.bankTitle,
                              callback: function ($$v) {
                                _vm.$set(testbank, "bankTitle", $$v)
                              },
                              expression: "testbank.bankTitle",
                            },
                          }),
                        ]
                      : [_vm._v(_vm._s(testbank.bankTitle))],
                  ],
                  2
                ),
              ]),
              _c("div", { staticClass: "flex" }, [
                _c("div", { staticClass: "w-28 py-2 px-3 text-sm" }, [
                  _vm._v(_vm._s(_vm.$t("testBank.number.paper"))),
                ]),
                _c("div", { staticClass: "min-w-0 flex-1 py-2 px-3 text-sm" }, [
                  _vm._v(_vm._s(testbank.bankExamSize ?? "-")),
                ]),
              ]),
              _c("div", { staticClass: "flex" }, [
                _c("div", { staticClass: "w-28 py-2 px-3 text-sm" }, [
                  _vm._v(_vm._s(_vm.$t("link.regDate"))),
                ]),
                _c("div", { staticClass: "min-w-0 flex-1 py-2 px-3 text-sm" }, [
                  _vm._v(_vm._s(testbank.regDate ?? "-")),
                ]),
              ]),
              _c("div", { staticClass: "py-2 px-3 flex justify-center" }, [
                _vm.isEditTestbank(testbank)
                  ? _c(
                      "div",
                      { staticClass: "w-full flex justify-center gap-x-1" },
                      [
                        _c(
                          "GrmBtn",
                          {
                            staticClass: "flex-1",
                            attrs: { size: "sm" },
                            on: {
                              click: function ($event) {
                                return _vm.onCreateTestbank($event, testbank)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("common.register")))]
                        ),
                        _c(
                          "GrmBtn",
                          {
                            staticClass: "flex-1",
                            attrs: { size: "sm", color: "red" },
                            on: {
                              click: function ($event) {
                                return _vm.onCancelTestbank($event, testbank)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("common.cancel")))]
                        ),
                      ],
                      1
                    )
                  : _c(
                      "div",
                      { staticClass: "w-full flex gap-x-1" },
                      [
                        _c(
                          "GrmBtn",
                          {
                            staticClass: "flex-1",
                            attrs: { size: "sm" },
                            on: {
                              click: function ($event) {
                                return _vm.onSelectTestbank(testbank)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("common.see")))]
                        ),
                        _c(
                          "GrmBtn",
                          {
                            staticClass: "flex-1",
                            attrs: { size: "sm", color: "red" },
                            on: {
                              click: function ($event) {
                                return _vm.onDeleteTestbank($event, testbank)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("common.delete")))]
                        ),
                      ],
                      1
                    ),
              ]),
            ]
          )
        }),
        0
      ),
      !_vm.testbankList?.content?.length
        ? _c("div", { staticClass: "lg:hidden" }, [
            _c(
              "p",
              { staticClass: "text-center p-2 rounded bg-gray-100 text-sm" },
              [_vm._v(_vm._s(_vm.$t("testBank.notExist")))]
            ),
          ])
        : _vm._e(),
      _c("GrmPagination", {
        staticClass: "mt-3",
        attrs: { pageInfo: _vm.testbankList.pageInfo },
        on: {
          paging: (page) => {
            _vm.getTestbankList({ page })
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("colgroup", [
      _c("col", { attrs: { width: "4%" } }),
      _c("col", { attrs: { width: "20%" } }),
      _c("col", { attrs: { width: "6%" } }),
      _c("col", { attrs: { width: "8%" } }),
      _c("col", { attrs: { width: "6%" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("colgroup", [
      _c("col", { attrs: { width: "4%" } }),
      _c("col", { attrs: { width: "20%" } }),
      _c("col", { attrs: { width: "6%" } }),
      _c("col", { attrs: { width: "8%" } }),
      _c("col", { attrs: { width: "6%" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }